import { useEffect, useState } from "react";
import { Download, LineChart, Link2, SlidersHorizontal } from "lucide-react";
import { SearchBox } from "./SearchBox";

const Clock = () => {
  const [now, setNow] = useState(new Date());
  useEffect(() => { const id = setInterval(() => setNow(new Date()), 1000); return () => clearInterval(id); }, []);
  return <em>{now.toLocaleTimeString("en-IN", { timeZone: "Asia/Kolkata", hour12: false })} IST</em>;
};

export const TopBar = ({ status, onOpenGroww, onOpenStrategy, onInstall, onPick }) => <header className="topbar">
  <div className="brand"><div className="brand-mark"><LineChart size={17} /></div><div><b>Northstar</b><span>INTRADAY</span></div></div>
  <SearchBox onPick={onPick} />
  <div className="top-actions">
    <div className="session"><span className="live-dot" />NSE <Clock /></div>
    {onInstall && <button className="install-btn" data-testid="install-app-button" onClick={onInstall}><Download size={14} /> Install app</button>}
    <button className="secondary-btn" data-testid="strategy-settings-button" onClick={onOpenStrategy}><SlidersHorizontal size={14} /> Strategy</button>
    <button className={`groww-btn ${status.connected ? (status.token_state === "expired" ? "bad" : "on") : ""}`} data-testid="groww-account-button" onClick={onOpenGroww}><Link2 size={14} /> {status.connected ? (status.token_state === "expired" ? "Groww token expired" : "Groww connected") : "Connect Groww"}</button>
  </div>
</header>;
